import {WithoutSummaryModel} from '../../../../../common/entity/dto/plain/withoutSummary.model';
import {Scanner3dModel} from '../../../common/api/entity/scanner3d.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {Scanner3dAccountAgentConfigurationModel} from "./scanner3dAccountAgentConfiguration.model";

export class Scanner3dAccountModel extends WithoutSummaryModel{
    scanner: Scanner3dModel;
    scanMethod: LovValueSummary;
    scanFormat: LovValueSummary;
    referencial: LovValueSummary;
    footPosition: LovValueSummary;
    objectType: LovValueSummary;
    agentConfiguration: Scanner3dAccountAgentConfigurationModel;
    byDefault: boolean;
    withImage: boolean;
    immediateValidation: boolean;
}
